import React from 'react';
import '../styles/App.css';


import ControllerTable from "../controller/ControllerTable";
import FunctionTable from "../controller/FunctionTable";
import MethodTable from "../controller/MethodTable";
import RpoService from "../services/RpoService";
import RpoTable from "../controller/RpoTable";
import ModuleSelector from "../wsp/calibration-modules/ModuleSelector";
import CompleteHistory from "../wsp/calibration-modules/CompleteHistory";
import {trackPromise} from "react-promise-tracker";
import DthCalibrationTable from "../dth/calibration-modules/DthCalibrationTable";
import CalibrationTable from "../wsp/calibration-modules/CalibrationTable";
import GspasCalibrationTable from "../gspas/GspasCalibrationTable";
import HardwareDependencySelector from "../wsp/calibration-modules/HardwareDependencySelector";
import GspasHardwareSelector from "../gspas/GspasHardwareSelector";
import {api} from "../api/v1/api";
import GspasQuestionAnswerTable from "../gspas/GspasQuestionAnswerTable";

class Presenter extends React.Component{

    serverApi;
    rpoService;
    constructor(props) {
        super(props);
        this.state.vinDecode = this.props.objectData
        this.state.resetData = this.props.objectData
        this.serverApi = new api();
        this.rpoService = new RpoService()
        this.calTableHandler = this.calTableHandler.bind(this)
        this.completeHistoryHandler = this.completeHistoryHandler.bind(this)
        this.hardwareHandler = this.hardwareHandler.bind(this)
        this.sequenceHandler = this.sequenceHandler.bind(this)
        this.turnOffDisplay = this.turnOffDisplay.bind(this)
        this.gspasHardwareHandler = this.gspasHardwareHandler.bind(this)
        this.gspasInitHardwareHandler = this.gspasInitHardwareHandler.bind(this)
        this.gspasCalDataHandler = this.gspasCalDataHandler.bind(this)
        this.handleQuestionAnswerSelection = this.handleQuestionAnswerSelection.bind(this)
        this.questionAnswerInitHandler = this.questionAnswerInitHandler.bind(this)
        this.handleControllerClick = this.handleControllerClick.bind(this)
        this.handleFunctionClick = this.handleFunctionClick.bind(this)
        this.handleMethodClick = this.handleMethodClick.bind(this)
        this.rpoServiceHandlerWsp = this.rpoServiceHandlerWsp.bind(this)
        this.rpoServiceHandlerDth = this.rpoServiceHandlerDth.bind(this)
        this.handleRpoQuestionClickWsp = this.handleRpoQuestionClickWsp.bind(this)
        this.handleRpoQuestionClickDth = this.handleRpoQuestionClickDth.bind(this)
        this.rpoListHandler = this.rpoListHandler.bind(this)
        this.vinDecodeRpoHandler = this.vinDecodeRpoHandler.bind(this)
        this.rpoRenderListHandler = this.rpoRenderListHandler.bind(this)
        this.naoVinSelectionHandler = this.naoVinSelectionHandler.bind(this)
        this.isNAOCalData = this.isNAOCalData.bind(this)
        this.programmingSequenceHandler = this.programmingSequenceHandler.bind(this)
    }
    state = {
        //RenderBooleans
        renderFunctionTable: false,
        renderMethodTable: false,
        renderRpoTable: false,
        renderModuleSelector: false,
        renderHardwareSelector: false,
        renderGspasQuestionAnswer: false,
        renderCalPres: false,
        renderCompleteHistory: false,
        hasCalibrationData: false,
        renderPartDecisionSelector: false,

        //State Variable Centered Around Controller Selection
        init: true,
        controllerIndex: -1,
        functionIndex: -1,
        methodIndex: -1,
        rpoIndex: -1,
        additionalRpoIndices: [],
        isRPO: false,
        rpoLabel: null,
        postOPKey: null,
        postOPValue: null,
        postRpoQuestions: [],
        additionalRpoQuestions:[],
        renderAdditionalRpo: false,
        displayName: [],
        controllerFunction: [],
        programmingMethod: [],
        productionOption: [],
        rpoLocation:{top: 0, left:0},
        additionalRpoLocations: [],
        programmingSequenceData: null,
        vinDecode: null,
        resetData: null,
        initialLoad: false,
        rpoState: null,
        initialComposite: null,
        selectedFunctions: [],
        selectedMethods:[],
        selectedOptions: [],
        singleFunctionRerender: false,
        singleMethodRerender: false,
        singlePostOptionRerender: false,

        //State Variable With Respect To Calibration Presenter && GSPAS Extra Logic
        sequenceID: -1,
        calibrationData: null,

        renderCalibrationTable: false,
        qaInitialRender: true,
        moduleId: -1,
        hardwareId: -1,
        modName: "",
        gspasSelectCounter: 0,
        gspasSelectLimit: -1,
        questionAnswerCounter: 0,
        questionAnswerLimit: -1,
        gspasCalData: null,
    }



    render(){
        return(
            <div className={"presenter-view"}>
                <div className={"controllerPresenterCol1"}>
                    <ControllerTable
                        controllers = {this.props.controllers}
                        controllerIndex = {this.state.controllerIndex}
                        handleControllerClick = {this.handleControllerClick}
                    />
                </div>

                <div className={"controllerPresenterCol2"}>
                    {this.state.renderFunctionTable ? (
                        <FunctionTable
                            functions = {this.state.selectedFunctions}
                            functionIndex = {this.state.functionIndex}
                            handleFunctionClick = {this.handleFunctionClick}
                            singleFunction = {this.state.singleFunctionRerender}
                        />
                    ):(<React.Fragment/>)}
                    {this.state.renderMethodTable ? (
                        <MethodTable
                            methods = {this.state.selectedMethods}
                            methodIndex = {this.state.methodIndex}
                            handleMethodClick = {this.handleMethodClick}
                            singleMethod = {this.state.singleMethodRerender}
                        />
                    ):(<React.Fragment/>)}
                </div>

                <div className={"controllerPresenterCol3"}>
                    {this.state.renderRpoTable ?(
                        <RpoTable
                            adapterType = {this.props.adapterType}
                            rpoLabel = {this.state.rpoLabel}
                            postRpoQuestions = {this.state.postRpoQuestions}
                            postRpoIndex = {this.state.rpoIndex}
                            additionalRpoIndices = {this.state.additionalRpoIndices}
                            additionalRpoQuestions = {this.state.additionalRpoQuestions}
                            handleRpoQuestionClickWsp = {this.handleRpoQuestionClickWsp}
                            handleRpoQuestionClickDth = {this.handleRpoQuestionClickDth}
                            rpoDthQuestions = {this.state.initialComposite}
                            rpoState = {this.state.rpoState}
                            renderAdditionalRpo = {this.state.renderAdditionalRpo}
                            rpoLocations = {this.state.additionalRpoLocations}
                            singlePostOption = {this.state.singlePostOptionRerender}
                        />
                    ):(<React.Fragment/>)}
                    {this.state.renderHardwareSelector ? (
                        <React.Fragment>
                            {this.props.adapterType === "GSPASVin" ?
                                (<GspasHardwareSelector
                                        progSeqData = {this.state.gspasCalData}
                                        hardwareHandler = {this.gspasHardwareHandler}
                                        initHardwareHandler = {this.gspasInitHardwareHandler}
                                        hardwareSelectionCount = {this.state.gspasSelectCounter}
                                        getGspasCalDataCounter = {this.state.gspasSelectLimit}
                                        calDataHandler = {this.gspasCalDataHandler}
                                        serverApi = {this.serverApi}
                                        errorHandler = {this.props.errorHandler}
                                    />
                                ):(
                                    <HardwareDependencySelector hardwareList={this.state.programmingSequenceData.defaultDataHardwareList}
                                                                progSeqData={this.state.programmingSequenceData}
                                                                hardwareHandler={this.hardwareHandler}
                                                                turnOffDisplay={this.turnOffDisplay}
                                    />
                                )}
                        </React.Fragment>
                    ):(<React.Fragment/>)}
                    {this.state.renderPartDecisionSelector ? (
                        <HardwareDependencySelector hardwareList = {this.state.programmingSequenceData.defaultPartList}
                                                    progSeqData = {this.state.programmingSequenceData}
                                                    hardwareHandler = {this.hardwareHandler}
                                                    turnOffDisplay = {this.turnOffDisplay}
                        />
                    ):(<React.Fragment/>)}
                    {this.state.renderModuleSelector ? (
                        <ModuleSelector progSeqData={this.state.programmingSequenceData}
                                        modules={this.state.programmingSequenceData.moduleData}
                                        hardwareId={this.state.hardwareId}
                                        calHandler={this.calTableHandler}
                                        cmplHisHandler={this.completeHistoryHandler}
                                        turnOffDisplay={this.turnOffDisplay}
                    />):(<React.Fragment/>)}
                    {this.state.renderGspasQuestionAnswer ? ( <GspasQuestionAnswerTable
                        progSeqData = {this.state.programmingSequenceData}
                        qaCounter = {this.state.questionAnswerCounter}
                        qaLimit = {this.state.questionAnswerLimit}
                        QuestionAnswer = {this.state.programmingSequenceData.normalProgrammingVO.questionAnswerMap}
                        initHandler = {this.questionAnswerInitHandler}
                        qaHandler = {this.handleQuestionAnswerSelection}
                        calDataHandler = {this.gspasCalDataHandler}
                        qaInitialRender = {this.state.qaInitialRender}
                        errorHandler = {this.props.errorHandler}
                    />):(<React.Fragment/>)}
                </div>
                <div className={"calibrationPresenter"}>
                    {this.state.programmingSequenceData ? (
                        <React.Fragment>
                            {!this.state.hasCalibrationData ? (
                                <div className={"NoValidCop"}>
                                    <h2>No Calibration Data To Display</h2>
                                </div>
                            ):(
                                <React.Fragment>
                                    {this.props.adapterType === "NAOVin" ? (
                                        <div>
                                            {this.state.renderCalibrationTable ? (
                                                <CalibrationTable chainOfParts={this.state.calibrationData}
                                                                  hasDependency={this.state.programmingSequenceData.hasDependency}
                                                                  progSeqData={this.state.programmingSequenceData}
                                                                  hardwareId={this.state.hardwareId}
                                                                  moduleId={this.state.moduleId}
                                                                  moduleName = {this.state.moduleName}
                                                />
                                            ) : (<React.Fragment/>)}
                                            {this.state.renderCompleteHistory ? (
                                                <CompleteHistory progSeqData={this.state.programmingSequenceData}
                                                                 modules={this.state.programmingSequenceData.moduleData}
                                                                 chainOfParts={this.state.programmingSequenceData.calibrationData}
                                                                 hardwareId={this.state.hardwareId}/>
                                            ):(<React.Fragment/>)}
                                        </div>
                                    ) : (<React.Fragment/>)}
                                    {this.props.adapterType === "GMEVin" ? (
                                        <div>
                                            {this.state.renderCalibrationTable ? (
                                                <DthCalibrationTable progSeqData={this.state.programmingSequenceData}
                                                                     modules={this.state.programmingSequenceData.moduleData}
                                                                     chainOfParts={this.state.programmingSequenceData.calibrationData}
                                                                     hardwareId={this.state.hardwareId}/>
                                            ) : (<React.Fragment/>)}
                                        </div>
                                    ) : (<React.Fragment/>)}
                                    {this.props.adapterType === "GSPASVin" ?(
                                        <div>
                                            {this.state.renderCalibrationTable ? (
                                                <GspasCalibrationTable progSeqData={this.state.programmingSequenceData}
                                                                       stepCalData={this.state.programmingSequenceData.stepCalData}
                                                                       stepDescriptions = {this.state.programmingSequenceData.stepDescriptions}
                                                />
                                            ):(<React.Fragment/>)}
                                        </div>
                                    ):(<React.Fragment/>)}
                                </React.Fragment>)}

                        </React.Fragment>
                    ):(<React.Fragment/>)}
                </div>
            </div>
        )
    }




    /*********************BEGIN CONTROLLER PRESENTER FUNCTIONS***************************/
    /**
     * Handles the initial load of the Controller Presenter, storing data that is needed
     * @returns {Promise<void>}
     */
    async initLoad(){
        await this.setState({
            init: false,
            vinDecode: this.props.objectData,
            resetData: this.props.objectData,
        })
    }

    /**
     * Handler for when a user make a selection on the controller table
     * @param data  The selected controller
     * @param index Index of selected controller
     * @returns {Promise<void>}
     */
    async handleControllerClick(data, index){
        await this.resetVinDataControllerClick()
        await this.setState({
            renderFunctionTable: false
        })
        await this.props.calPresenterHandler()
        let controllerCode = this.props.controllerReferenceTree[index][0].controllerCode
        let controllerLabel = this.props.controllerReferenceTree[index][0].controllerLabel
        let displayNameDisplayOrder = this.props.controllerReferenceTree[index][0].displayOrder
        let displayNameContents = [controllerCode, controllerLabel, displayNameDisplayOrder]

        await this.setState({
            selectedFunctions: this.props.functions[index],
            displayName: displayNameContents,
            controllerFunction: [],
            programmingMethod: [],
            productionOption: [],
            controllerIndex: index,
            functionIndex: -1,
            methodIndex: -1,
            rpoIndex: -1,
            additionalRpoIndices: [],
            renderFunctionTable: true,
            renderMethodTable: false,
            renderRpoTable: false,
            renderAdditionalRpo: false,
            renderCalPresenter: false,
            isRPO: false,
            postOPKey: null,
            postOPValue: null,
            singleFunctionRerender: false,
            programmingSequenceData: null,
            renderModuleSelector: false,
            renderHardwareSelector: false,
            renderGspasQuestionAnswer: false,
            renderCalibrationTable: false,
            gspasSelectCounter: 0,
            gspasSelectLimit: -1,
            questionAnswerCounter: 0,
            questionAnswerLimit: -1,
            hasCalibrationData: true,
            hardwareId: -1,
            renderPartDecisionSelector: false
        })
    }

    /**
     * Handler for when user selects a controller functions
     * @param data  The selected controller functions
     * @param index The selected controller function index
     * @param singleFunction indicates if a single functin was present in list, so that selection was made not by user
     * @returns {Promise<void>}
     */
    async handleFunctionClick(data, index, singleFunction){
        await this.resetVinDataFunctionClick()
        await this.setState({
            renderMethodTable: false
        })
        await this.props.calPresenterHandler()
        let functionDisplayOrder = this.state.selectedFunctions[index][0].displayOrder
        let functionLabel = this.state.selectedFunctions[index][0].functionLabel

        let functionContents = [functionDisplayOrder, functionLabel]

        await this.setState({
            selectedMethods: this.props.methods[this.state.controllerIndex][index],
            controllerFunction: functionContents,
            functionIndex: index,
            renderMethodTable: true,
            renderRpoTable: false,
            renderAdditionalRpo: false,
            programmingMethod: [],
            productionOption: [],
            methodIndex: -1,
            rpoIndex: -1,
            additionalRpoIndices: [],
            renderCalPresenter: false,
            isRPO: false,
            postOPKey: null,
            postOPValue: null,
            singleFunctionRerender: singleFunction,
            renderCalibrationTable: false,
            gspasSelectCounter: 0,
            gspasSelectLimit: -1,
            questionAnswerCounter: 0,
            questionAnswerLimit: -1,
            hasCalibrationData: true,
            hardwareId: -1,
            programmingSequenceData: null,
            renderModuleSelector: false,
            renderPartDecisionSelector: false
        })
    }

    /**
     * Handler for when a user selects a method
     * @param data  The selected method
     * @param index The selected method index
     * @param singleMethod  Indicates if there was just a single method, so the user did no make the selections
     * @returns {Promise<void>}
     */
    async handleMethodClick(data, index, singleMethod){
        await this.resetVinDataMethodClick()
        await this.setState({
            renderRpoTable: false
        })
        await this.props.calPresenterHandler()
        let methodId = this.state.selectedMethods[index][0].methodId
        let methodDesc = this.state.selectedMethods[index][0].description
        let methodBlock = this.state.selectedMethods[index][0].blockSameCal

        let programmingMethodContents = [methodId, methodDesc, methodBlock]

        let v = await this.serverApi.setVinDecode(this.state.vinDecode,
            this.state.displayName, this.state.controllerFunction,
            programmingMethodContents)

        await this.setState({
            methodIndex: index,
            rpoIndex: -1,
            programmingMethod: programmingMethodContents,
            renderCalPresenter: false,
            vinDecode: v,
            singleMethodRerender: singleMethod,
            renderCalibrationTable: false,
            hasCalibrationData: true,
            hardwareId: -1,
            programmingSequenceData: null,
            renderModuleSelector: false,
            renderHardwareSelector: false,
            renderPartDecisionSelector: false
        })

        await this.rpoService.checkForRpo(this.state.selectedMethods[index],
            this.props.adapterType, this.rpoServiceHandlerWsp,
            this.rpoServiceHandlerDth)
        if(this.state.renderRpoTable){

        }
        else{
            await trackPromise(this.serverApi.getCalibrationData(this.state.vinDecode,
                this.programmingSequenceHandler, this.props.errorHandler, this.isNAOCalData))
        }

    }

    /**
     * Handler for when user selects a rpo question for NAOVin
     * @param data  The selected rpo
     * @param index The selected rpo index
     * @param singlePO Indicates if there was just a single rpo, so the user did not make the selection
     * @returns {Promise<void>}
     */
    async handleRpoQuestionClickWsp(data, index, singlePO){
        await this.turnOffCallViewers()
        if(this.state.singlePostOptionRerender !== singlePO){
            await this.setState({
                singlePostOptionRerender: singlePO
            })
        }
        await this.rpoService.updateWspRpoStateObjects(this.state, data, index, this.props.calPresenterHandler,
            this.naoVinSelectionHandler)

    }

    /**
     * Handler for when user selects a rpo question for GMEVin
     * @param data  The selected rpo
     * @param index The selected rpo index
     * @param questionIndex The selected rpo question index
     * @param rpoReselectHandler  Handler used to reselect rpo questions
     * @returns {Promise<void>}
     */
    async handleRpoQuestionClickDth(data, index, questionIndex, rpoReselectHandler){
        await this.turnOffCallViewers()
        await this.rpoService.updateDthRpoStateObjects(this.state, data, index, questionIndex, this.props.calPresenterHandler,
            this.rpoListHandler, this.vinDecodeRpoHandler, this.rpoRenderListHandler, rpoReselectHandler)
    }

    /**
     * Handler that sets the rpo questions for a NAOVin
     * @param rpoQuestions  Rpo Questions to rendered
     * @param label         Label describing RPO Question
     * @returns {Promise<void>}
     */
    async rpoServiceHandlerWsp(rpoQuestions, label){
        await this.setState({
            rpoLabel: label,
            isRpo: true,
            renderRpoTable: true,
            postRpoQuestions: rpoQuestions,
            renderAdditionalRpo: false,
            hasCalibrationData: true,
            programmingSequenceData: null,
        })
    }

    /**
     * Handler that sets the rpo questions for a GMEVin
     * @param rpoQuestions  Rpo Questions to rendered
     * @param composite   Composite to be rendered
     * @param additionalRpoQuestions  Additional Rpo Questions to be rendered
     * @param rpoLocations Locations of composites on page
     * @returns {Promise<void>}
     */
    async rpoServiceHandlerDth(rpoQuestions, composite, additionalRpoQuestions, rpoLocations){
        await this.setState({
            isRpo: true,
            renderRpoTable: true,
            postRpoQuestions: rpoQuestions,
            rpoState: composite,
            initialComposite: composite,
            renderAdditionalRpo: false,
            additionalRpoQuestions: additionalRpoQuestions,
            additionalRpoLocations: rpoLocations,
            hasCalibrationData: true,
            programmingSequenceData: null,
        })
    }

    /**
     * Resets data in VinDecode object when user reselects a controller
     * @returns {Promise<void>}
     */
    async resetVinDataControllerClick(){
        this.state.vinDecode.controllerFunction = this.props.dataReset.controllerFunction
        this.state.vinDecode.programmingMethod = this.props.dataReset.programmingMethod
        this.state.vinDecode.productionOption = this.props.dataReset.productionOption
        this.state.vinDecode.rpoCodes = []
    }

    /**
     * Resets data in VinDecode object when user reselects a functions
     * @returns {Promise<void>}
     */
    async resetVinDataFunctionClick(){
        this.state.vinDecode.programmingMethod = this.props.dataReset.programmingMethod
        this.state.vinDecode.productionOption = this.props.dataReset.productionOption
        this.state.vinDecode.rpoCodes = []
    }

    /**
     * Resets data in VinDecode object when user reselects a method
     * @returns {Promise<void>}
     */
    async resetVinDataMethodClick(){
        this.state.vinDecode.productionOption = this.props.dataReset.productionOption
        this.state.vinDecode.rpoCodes = []
    }

    /**
     * Resets data in VinDecode object when user reselects an rpo question
     * @returns {Promise<void>}
     */
    async resetVinDataRpoClick(){

    }

    /**
     * Handler for DTH Rpo Lists that are used in rendering
     *
     * @param addRpoQuestions   additionalRpoQuestions List
     * @param addRpoLocations   additionalRpoLocations List
     * @param addRpoIndices     additionalRpoIndices List
     * @param index             index of question
     * @returns {Promise<void>}
     */
    async rpoListHandler(addRpoQuestions, addRpoLocations, addRpoIndices, index){
        this.state.vinDecode.rpoCodes = await this.rpoService.removeListTail(index, this.state.vinDecode.rpoCodes)
        await this.setState({
            additionalRpoQuestions: addRpoQuestions,
            additionalRpoLocations: addRpoLocations,
            additionalRpoIndices: addRpoIndices,
        })
    }

    /**
     * Handler for when need to update codesto send to sps2info backend and maybe obtain calibration data for GMEVin
     * @param selection         The selected Rpo Question
     * @param selectIndices     Index of selection
     * @param getCalibration    Value indicating whether or not to obtain calibrations
     * @returns {Promise<void>}
     */
    async vinDecodeRpoHandler(selection, selectIndices, getCalibration){
        this.state.vinDecode.rpoCodes.push(selection)
        await this.setState({
            additionalRpoIndices: selectIndices
        })
        if(getCalibration){
            await trackPromise(this.serverApi.getCalibrationData(
                this.state.vinDecode, this.programmingSequenceHandler, this.props.errorHandler
            ))
        }
    }

    /**
     * Handler that has to do with updating list of composites to render for GMEVin
     * @param updatedComposites List of updated composites
     * @param rpoLocations  Locations of composites on page
     * @returns {Promise<void>}
     */
    async rpoRenderListHandler(updatedComposites, rpoLocations){
        await this.setState({
            additionalRpoQuestions: updatedComposites,
            additionalRpoLocations: rpoLocations,
        })
    }

    /**
     * Handler dealing when a selection has been made for a NAOVin rpo question
     * @param index index of selection
     * @param productionOptionContents  production option contents to be set
     * @returns {Promise<void>}
     */
    async naoVinSelectionHandler(index, productionOptionContents){
        await this.setState({
            rpoIndex: index,
            productionOption: productionOptionContents
        })

        let vinDecode = await this.serverApi.setVinDecodePostOp(this.state.vinDecode, productionOptionContents,
            this.state.selectedMethods[this.state.methodIndex][1].options[0].selections)

        await trackPromise(this.serverApi.getCalibrationData(vinDecode, this.programmingSequenceHandler,
            this.props.errorHandler))
    }
    /*********************END CONTROLLER PRESENTER FUNCTIONS***************************/



    /*******************BEGIN CALIBRATION PRESENTER FUNCTION***************************/
    /**
     * Handler used to turn off displays, usually when user clicks on a selection to get ready for rerendering
     * @returns {Promise<void>}
     */
    async turnOffDisplay(){
        await this.setState({
            renderCalibrationTable: false,
            renderCompleteHistory: false,
        })
    }

    /**
     * Calibration Table Handler for NAOVin
     * @param modId Selected module id
     * @param modName   Selected module name
     * @param calData   Calibration Data
     * @returns {Promise<void>}
     */
    async calTableHandler(modId, modName, calData){
        if (this.state.programmingSequenceData.isNaoCalDataPartDecision !== undefined){
            if(this.state.programmingSequenceData.partDecisionExists[modId]) {
                await this.setState({
                    moduleName: modName,
                    calibrationData: calData,
                    moduleId: modId,
                    renderPartDecisionSelector: true,
                })
            }
            else {
                await this.setState({
                    moduleName: modName,
                    calibrationData: calData,
                    moduleId: modId,
                    renderCalibrationTable: true,
                    renderCompleteHistory: false,
                    renderPartDecisionSelector: false,
                })
            }
        }else {
            await this.setState({
                moduleName: modName,
                calibrationData: calData,
                moduleId: modId,
                renderCalibrationTable: true,
                renderCompleteHistory: false,
                renderPartDecisionSelector: false,
            })
        }
    }

    /**
     * Handler used when having to render complete history for NAOVin
     * @returns {Promise<void>}
     */
    async completeHistoryHandler(){
        await this.setState({
            renderCalibrationTable: false,
            renderCompleteHistory: true,
            renderPartDecisionSelector: false,
        })
    }

    /**
     * Handler used when user makes a hardware number selection
     * @param hardwareNumber selected hardware number
     * @returns {Promise<void>}
     */
    async hardwareHandler(hardwareNumber){
        if(this.state.programmingSequenceData.isNaoCalDataPertDecision !== undefined) {
            await this.setState({
                renderModuleSelector: false,
            })
        }
        if(this.props.adapterType === "GMEVin"){
            await this.turnOffDisplay()
            await this.setState({
                renderCalibrationTable: true,
                hardwareId: hardwareNumber,
                renderModuleSelector: false,
                renderCompleteHistory: false,
            })
        }
        if(this.props.adapterType === "NAOVin"){
            if(this.state.programmingSequenceData.isNaoCalDataPartDecision !== undefined){
                await this.setState({
                    hardwareId: hardwareNumber,
                    renderCalibrationTable: true,
                })
            }else {
                await this.setState({
                    renderModuleSelector: true,
                    hardwareId: hardwareNumber,
                })
                await this.completeHistoryHandler()
            }
        }
    }

    /**
     * I dont think this is needed, but need to double check
     * @param seqId
     * @returns {Promise<void>}
     */
    async sequenceHandler(seqId){
        await this.setState({
            sequenceId: seqId,
            renderHardwareSelector : this.state.programmingSequenceData.hasDependency
        })
    }

    /**
     * Handler for when used makes selection of hardware poart number for Gspas Vin
     * @param stepId    Step Id
     * @param partNumber    Selected hardware number
     * @returns {Promise<void>}
     */
    async gspasHardwareHandler(stepId, partNumber, reselection){
        this.state.gspasCalData.stepIdPartNumberMap[stepId] = partNumber
        let updateCounter = reselection ? this.state.gspasSelectCounter : this.state.gspasSelectCounter + 1
        await this.setState({
            gspasSelectCounter: updateCounter,
            renderCalibrationTable: false,
        })
    }

    /**
     * Handler used when Gspas Calibratin Data with hardware dependency is set back. Sets the amount of selections
     * needed before a call to the backend can be made
     * @param totalSelections   Number of selectins needed
     * @returns {Promise<void>}
     */
    gspasInitHardwareHandler(totalSelections){
        this.setState({
            gspasSelectLimit: totalSelections
        })
    }

    /**
     * Handler used to store the Gspas Calibration Data returned from the Sps2 info backend
     * @param calData
     * @returns {Promise<void>}
     */
    async gspasCalDataHandler(calData){
        await this.setState({
            programmingSequenceData: calData,
            renderCalibrationTable: true,
        })
    }

    /**
     * Handler used when Gspac Calibration Data is returned and a Gspoas Question & Anser needs to be selected
     * @param totalQuestions    total number of questins
     * @param initRender    tells front end the handler has been called
     * @returns {Promise<void>}
     */
    async questionAnswerInitHandler(totalQuestions, initRender){
        await this.setState({
            questionAnswerLimit: totalQuestions,
            qaInitialRender: initRender
        })
    }

    /**
     * Handler for when gspas question & anseer is selected
     * @param questionIndex Index of where question is located
     * @param questionAnswer    Answer to question
     * @returns {Promise<void>}
     */
    async handleQuestionAnswerSelection(questionIndex, questionAnswer){
        this.state.programmingSequenceData.normalProgrammingVO.questionAnswerMap[questionIndex] =
            await questionAnswer
        await this.setState({
            questionAnswerCounter: this.state.questionAnswerCounter + 1
        })
    }
    /*******************BEGIN CALIBRATION PRESENTER FUNCTION***************************/


    async isGMECalData(programmingSeq){

    }
    async isGSPASCalData(){

    }
    async isNAOCalData(programmingSeq){

        await this.setState({
            renderModuleSelector: true,
            programmingSequenceData: programmingSeq,
            renderCompleteHistory: true,
        })
    }

    /**
     * Handler used when trying to retrieve the calibration data from the SPS2 Info Backend
     *
     * @param programmingSeq The CalibrationData Object returned from the SPS2 Info Backend
     * @returns {Promise<void>}
     */
    async programmingSequenceHandler(programmingSeq){
        if(!programmingSeq.hasValidChainOfParts){
            await this.setState({
                hasCalibrationData: false,
                programmingSequenceData: programmingSeq,
            })
            return
        }


        if(programmingSeq.hasDependency){
            this.setState({
                renderHardwareSelector: true,
                programmingSequenceData: programmingSeq,
            });

            if(this.props.adapterType === "GSPASVin"){
                await this.setState({
                    gspasCalData: programmingSeq
                })
            }
        }else {
            if (this.props.adapterType === "NAOVin") {
                await this.isNAOCalData(programmingSeq)
            }
            else if(this.props.adapterType === "GSPASVin"){
                if(programmingSeq.hasQuestionAnswer){
                    await this.setState({
                        renderGspasQuestionAnswer: true,
                        programmingSequenceData: programmingSeq,
                    })
                }else{
                    await this.setState({
                        programmingSequenceData: programmingSeq,
                        renderCalPresenter: true,
                        renderCalibrationTable: true,
                    })
                }
            }
            else {
                await this.setState({
                    programmingSequenceData: programmingSeq,
                    renderCalPresenter: true,
                    renderCalibrationTable: true,
                })
            }
        }
    }

    async turnOffCallViewers(){
        await this.setState({
            renderCalPresenter: false,
            renderCalibrationTable: false,
            programmingSequenceData: null,
            renderHardwareSelector: false,
            renderModuleSelector: false,
            renderCompleteHistory: false,
            hardwareId: -1,
        })
    }
}

export default Presenter;